import moment from "moment";

/**
 * Returna {true} si el rango de fecha indicado no sobrepasa la cantidad de
 * días esperados
 *
 * @param {string} fechaInicio String en formato YYYY-MM-DD
 * @param {string} fechaFin String en formato YYYY-MM-DD
 * @param {*} diasMaximos
 * @returns {boolean}
 */
export const validarRangoDeFecha = (fechaInicio, fechaFin, diasMaximos) => {
    fechaInicio = moment(fechaInicio);
    fechaFin = moment(fechaFin);

    const duracion = moment.duration(fechaFin.diff(fechaInicio));
    const dias = duracion.asDays();

    return dias <= diasMaximos;
};
